import { usePageContext } from "../../../hooks/context";
import type { OnboardingPackageId } from "../../../types/package";
import { useChoosePackage } from "../hooks";
import BasePackageBlock from "../package-block/base-package-block";
import EhandelPackageBlock from "../package-block/e-handel-package-block";
import ForetagarnaCreditPackageBlock from "../package-block/foretagarna-credit-package-block";
import ForetagarnaPackageBlock from "../package-block/foretagarna-package-block";
import GrowPackageBlock from "../package-block/grow-package-block";
import OverDraftPackageBlock from "../package-block/overdraft-package-block";

export const useOnboardingPackagesMap = (): Record<OnboardingPackageId, React.ReactNode> => {
	const { availablePackages } = usePageContext(useChoosePackage);

	const [
		basePackage,
		growPackage,
		overDraftPackage,
		foretagarnaPackage,
		foretagarnaCreditPackage,
		ehandelPackage,
	] = availablePackages;

	const OnboardingPackagesMap: Record<OnboardingPackageId, React.ReactNode> = {
		"FORETAGARNA-CARDONLY": (
			<ForetagarnaCreditPackageBlock foretagarnaCreditPackage={foretagarnaCreditPackage} />
		),
		"BAAS-FÖRETAG-VÄXA": <GrowPackageBlock growPackage={growPackage} />,
		"BAAS-FÖRETAG-BAS": <BasePackageBlock basePackage={basePackage} />,
		OVERDRAFTPACKAGE: <OverDraftPackageBlock overDraftPackage={overDraftPackage} />,
		"FÖRETAGARNA-BAS": <ForetagarnaPackageBlock foretagarnaPackage={foretagarnaPackage} />,
		"E-HANDEL-BAS": <EhandelPackageBlock ehandelPackage={ehandelPackage} />,
	};

	return OnboardingPackagesMap;
};
